import React, { useEffect, useState } from 'react'
import {
  Box,
  Button,
  Card,
  Checkbox,
  CircularProgress,
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  ListItemText,
  Menu,
  MenuItem,
  Tab,
  Tabs,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import CancelIcon from '@mui/icons-material/Cancel'
import InfiniteScroll from 'react-infinite-scroller'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import ContactSupportIcon from '@mui/icons-material/ContactSupport'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import SendIcon from '@mui/icons-material/Send'
import MenuTwoToneIcon from '@mui/icons-material/MenuTwoTone'
import DoneTwoToneIcon from '@mui/icons-material/DoneTwoTone'
import HourglassEmptyTwoToneIcon from '@mui/icons-material/HourglassEmptyTwoTone'
import WarningAmberTwoToneIcon from '@mui/icons-material/WarningAmberTwoTone'
import CloseTwoToneIcon from '@mui/icons-material/CloseTwoTone'
import { message } from 'antd'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import LayersClearIcon from '@mui/icons-material/LayersClear'

import useAxios, { axiosInstance } from '../../../../../hooks/useAxios'
import ImgTag from '../../../../../components/ImgTag'
import { PaginationResponseInterface } from '../../../../../types/pagination'
import FacebookOrderDrawer from './FacebookOrderDrawer'
import pusher from '../../../../../constants/pusher'
import dayjs from 'dayjs'
import { Tag } from '../../../../../components/Tag'
import {
  FacebookMessageOrderDetailModal,
  IFacebookMessageOrder,
} from './FacebookMessageOrderDetailModal'
import FacebookOrder from './FacebookOrder'
import { EOrderStatus } from '../../../../../types/order'
import { ERRORS_MESSAGE_MAPPER } from '../../../../../constants/errors'
import FacebookOrderHistory from './FacebookOrderHistory'
import FacebookOrderHistoryDrawer from './FacebookOrderHistoryDrawer'

enum FacebookTabsChatEnum {
  ChatList = 'chatList',
  ChatArchiveList = 'chatArchiveList',
}

interface IFacebookPage {
  _id: string
  pageId: string
  accessToken: string
  createdAt: string
  imageUrl: string
  merchant: string
  objectId: string
  pageName: string
  updatedAt: string
}

export enum FacebookFilterMenuEnum {
  Pendding = 'pending',
  Purchased = 'purchased',
  Hold = 'hold',
  Cancelled = 'cancelled',
}

interface IFacebookAttachments {
  name: string
  size: number
  image_data: {
    width: number
    height: number
    max_width: number
    max_height: number
    url: string
    preview_url: string
    image_type: number
    render_as_sticker: boolean
  }
  id: string
}

interface IFacebookAttachment {
  type: string
  payload: {
    template_type: string
    recipient_name: string
    order_number: string
    currency: string
    payment_method: string
    order_url: string
    timestamp: string
    address: {
      street_1: string
      street_2: string
      city: string
      postal_code: string
      state: string
      country: string
    }
    summary: {
      subtotal: number
      shipping_cost: number
      total_tax: number
      total_cost: number
    }
    elements: {
      title: string
      subtitle: string
      quantity: number
      price: number
      currency: string
      image_url: string
    }[]
  }
}

interface IFacebookCursors {
  before: string
  after: string
}

interface IFacebookPaging {
  cursors: IFacebookCursors
  next: string
}

interface IFacebookAttachmentsData {
  data: IFacebookAttachments[]
  paging: IFacebookPaging
}

interface IFacebookMessage {
  message?: string
  id: string
  sticker?: string
  attachments?: IFacebookAttachmentsData
  attachment?: IFacebookAttachment
  from: {
    name: string
    email: string
    id: string
  }
  created_time: string
  to: {
    id: string
    name: string
  }
}

interface IFacebookFilterMenuChatArchiveList {
  pending?: boolean
  purchased?: boolean
  hold?: boolean
  cancelled?: boolean
}

interface IFacebookChatArchive {
  _id: string
  chatId: string
  merchant: string
  createdAt: string
  email: string
  name: string
  objectId: string
  pageId: string
  status: string
  updatedAt: string
  userId: string
}

interface IFacebookChat {
  id: string //chatId
  updateTime: string
  messages: {
    message: string
    id: string
  }[]
  receiver: {
    id: string
    email: string
    name: string
  }
  unReadCount: number
}

interface IFacebookChatDataFilter {
  chatId: string
  userId: string
  name: string
  email: string
  pageId?: string
}

const menuItemsTypeFilterChatArchiveList = [
  {
    label: 'ทั้งหมด',
    value: 'all',
  },
  {
    label: 'รอดำเนินการ',
    value: EOrderStatus.PENDING,
  },
  {
    label: 'รอดำเนินการจัดส่ง',
    value: EOrderStatus.TRACKING,
  },
  {
    label: 'ยกเลิก',
    value: EOrderStatus.CANCLELLED,
  },
  {
    label: 'ตีกลับ',
    value: EOrderStatus.RETURN,
  },
  {
    label: 'ตีกลับ (รับสินค้าแล้ว)',
    value: EOrderStatus.RETURNED,
  },
  {
    label: 'ระหว่างขนส่ง',
    value: EOrderStatus.TRANSIT,
  },
  {
    label: 'ส่งสำเร็จ',
    value: EOrderStatus.DELIVERED,
  },
  {
    label: 'สำเร็จ',
    value: EOrderStatus.SUCCESS,
  },
]

const FacebookReplyChat = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [tabChat, setTabChat] = useState<FacebookTabsChatEnum>(
    FacebookTabsChatEnum.ChatList,
  )
  const [isLoadingMessage, setIsLoadingMessage] = useState<boolean>(false)
  const [isOpenedOrderDrawer, setIsOpenedOrderDrawer] = useState<boolean>(false)
  const [isOpenedOrderHistoryDrawer, setIsOpenedOrderHistoryDrawer] =
    useState<boolean>(false)
  const [isOpenedOrderDetailModal, setIsOpenedOrderDetailModal] =
    useState<boolean>(false)
  const [messageOrderDetail, setMessageOrderDetail] =
    useState<IFacebookMessageOrder>()
  const [anchorElListPageMenu, setAnchorElListPageMenu] =
    useState<null | HTMLElement>(null)
  const [anchorElFilterMenu, setAnchorElFilterMenu] =
    useState<null | HTMLElement>(null)
  const [anchorElMenuSetStatusChat, setAnchorElMenuSetStatusChat] =
    useState<null | HTMLElement>(null)
  const [filter, setFilter] = useState<IFacebookFilterMenuChatArchiveList>({
    pending: false,
    purchased: false,
    hold: false,
    cancelled: false,
  })
  const [page, setPage] = useState<IFacebookPage>()
  const [chat, setChat] = useState<IFacebookChatDataFilter>()
  const [messageListData, setMessageListData] = useState<IFacebookMessage[]>()
  const [messagePaging, setMessagePaging] = useState<string>()
  const [replyMessage, setReplyMessage] = useState<string>()
  const [images, setImages] = useState<string[]>()
  const openListPageMenu = Boolean(anchorElListPageMenu)
  const openFilterMenu = Boolean(anchorElFilterMenu)
  const openMenuSetStatusChat = Boolean(anchorElMenuSetStatusChat)

  const onHandleSelectFilterMenuChatArchiveList = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setFilter({
      ...filter,
      [event.target.name]: event.target.checked,
    } as IFacebookFilterMenuChatArchiveList)
  }

  const onHandleSendImage = async () => {
    if (images?.length! < 1) return
    for (let i = 0; i < images?.length!; i++) {
      try {
        await axiosInstance.post('/facebook/pages/conversations/messages', {
          pageId: page?.pageId,
          message: images![i],
          recipient: chat?.userId,
          type: 'image',
        })
        setImages([])
        setMessageListData((prvMessageListData) => [
          ...(prvMessageListData || []),
          {
            message: '',
            id: '',
            sticker: '',
            attachments: {
              data: [
                {
                  name: '',
                  size: 0,
                  image_data: {
                    width: 0,
                    height: 0,
                    max_width: 0,
                    max_height: 0,
                    url: images![i],
                    preview_url: images![i],
                    image_type: 0,
                    render_as_sticker: false,
                  },
                  id: '',
                },
              ],
              paging: {
                cursors: {
                  before: '',
                  after: '',
                },
                next: '',
              },
            },
            from: {
              name: page?.pageName || '',
              email: '',
              id: page?.pageId || '',
            },
            created_time: new Date().toISOString(),
            to: {
              id: chat?.userId || '',
              name: chat?.name || '',
            },
          },
        ])
      } catch (e: any) {
        const messageError =
          ERRORS_MESSAGE_MAPPER?.[e.response?.data?.message ?? ''] ||
          'บันทึกข้อมูลไม่สำเร็จ'
        message.error(messageError)
      }
    }
  }

  const onHandleSendReplyMessage = async () => {
    if (replyMessage?.trim().length! < 1) return
    try {
      await axiosInstance.post('/facebook/pages/conversations/messages', {
        pageId: page?.pageId,
        message: replyMessage?.trim(),
        recipient: chat?.userId,
        type: 'message',
      })
      setReplyMessage('')
      setMessageListData((prvMessageListData) => [
        ...(prvMessageListData || []),
        {
          message: replyMessage || '',
          id: '',
          sticker: '',
          attachments: {
            data: [],
            paging: {
              cursors: {
                before: '',
                after: '',
              },
              next: '',
            },
          },
          from: {
            name: page?.pageName || '',
            email: '',
            id: page?.pageId || '',
          },
          created_time: new Date().toISOString(),
          to: {
            id: chat?.userId || '',
            name: chat?.name || '',
          },
        },
      ])
    } catch (e: any) {
      const messageError =
        ERRORS_MESSAGE_MAPPER?.[e.response?.data?.message ?? ''] ||
        'บันทึกข้อมูลไม่สำเร็จ'
      message.error(messageError)
    }
  }

  const onHandleSelectMultiFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    if (!event.target.files) {
      message.error('กรุณาเลือกไฟล์')
      return
    }

    const files = event.target.files
    const imageFiles = []

    for (let i = 0; i < files.length; i++) {
      const formData = new FormData()
      formData.append('file', files[i])
      try {
        const response = await axiosInstance.post('/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        imageFiles.push(response.data.url)
      } catch (e: any) {
        const messageError =
          ERRORS_MESSAGE_MAPPER?.[e.response?.data?.message ?? ''] ||
          'บันทึกข้อมูลไม่สำเร็จ'
        message.error(messageError)
      }
    }
    setImages([...(images || []), ...imageFiles])
  }

  const onHandleSelectSetStatusChat = async (
    status: FacebookFilterMenuEnum,
  ) => {
    setIsLoadingMessage(true)
    try {
      await axiosInstance.post('/facebook/pages/chatrooms', {
        chatRooms: [chat],
        status,
      })
      await chatArchiveList.mutate()
      message.success('เปลี่ยนสถานะแชทสำเร็จ')
    } catch (e: any) {
      const messageError =
        ERRORS_MESSAGE_MAPPER?.[e.response?.data?.message ?? ''] ||
        'บันทึกข้อมูลไม่สำเร็จ'
      message.error(messageError)
    }
    setIsLoadingMessage(false)
  }

  const pageList = useAxios<IFacebookPage[]>({
    method: 'GET',
    url: '/facebook/pages/available',
  })

  const chatList = useAxios<IFacebookChat[]>({
    method: 'GET',
    url: `/facebook/pages/conversations/${page?.pageId}`,
  })

  const chatArchiveList = useAxios<
    PaginationResponseInterface<IFacebookChatArchive>
  >({
    method: 'GET',
    url: '/facebook/pages/chatrooms',
    params: {
      pageId: page?.pageId,
      isPending: filter?.pending ? '1' : '0',
      isPurchased: filter?.purchased ? '1' : '0',
      isHold: filter?.hold ? '1' : '0',
      isCancelled: filter?.cancelled ? '1' : '0',
      page: 1,
      perPage: 10000,
    },
  })

  const onHandleMessageList = async () => {
    setIsLoadingMessage(true)
    const messageResponse: IFacebookMessage[] = []
    let pagingResponse = messagePaging
    for (let i = 0; i < 1; i++) {
      try {
        const response = await axiosInstance.get<{
          messages: IFacebookMessage[]
          paging: string
        }>(`/facebook/pages/conversations/${page?.pageId}/messages`, {
          params: {
            conversationId: chat?.chatId,
            paging: pagingResponse,
          },
        })
        pagingResponse = response.data.paging
        messageResponse.unshift(...response.data.messages.slice().reverse())
      } catch (e: any) {
        const messageError =
          ERRORS_MESSAGE_MAPPER?.[e.response?.data?.message ?? ''] ||
          'บันทึกข้อมูลไม่สำเร็จ'
        message.error(messageError)
      }
    }
    setMessagePaging(pagingResponse)
    setMessageListData([...messageResponse, ...(messageListData || [])])
    setIsLoadingMessage(false)
  }

  useEffect(() => {
    if (chat) {
      onHandleMessageList()
    }
  }, [chat])

  useEffect(() => {
    const channel = pusher.subscribe('goodorder-facebook-message')
    channel.bind(
      `${page?.pageId}-${chat?.userId}`,
      async function (data: IFacebookMessage) {
        setMessageListData((prvMessageListData) => [
          ...(prvMessageListData || []),
          {
            message: data.message || '',
            id: data.id || '',
            sticker: data.sticker || '',
            attachments: data.attachments || {
              data: [],
              paging: { cursors: { before: '', after: '' }, next: '' },
            },
            from: {
              name: chat?.name || '',
              email: chat?.email || '',
              id: chat?.userId || '',
            },
            created_time: new Date().toISOString(),
            to: {
              id: page?.pageId || '',
              name: page?.pageName || '',
            },
          },
        ])
      },
    )
    return () => {
      channel.unbind_all()
      channel.unsubscribe()
    }
  }, [chat])

  return (
    <>
      {!isOpenedOrderHistoryDrawer && chat?.name && (
        <IconButton
          onClick={() => setIsOpenedOrderDrawer(!isOpenedOrderDrawer)}
          sx={{
            backgroundColor: '#ffffff',
            width: isOpenedOrderDrawer ? 40 : 100,
            height: 50,
            borderRadius: '30px 0 0 30px',
            position: 'fixed',
            bottom: '500px',
            right: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {isOpenedOrderDrawer ? (
            <RemoveCircleOutlineIcon />
          ) : (
            <>
              <AddCircleOutlineIcon />
              <Box sx={{ marginLeft: 1 }}>
                <Typography variant="subtitle2">คำสั่งซื้อ</Typography>
              </Box>
            </>
          )}
        </IconButton>
      )}
      {!isOpenedOrderDrawer && chat?.name && (
        <IconButton
          onClick={() =>
            setIsOpenedOrderHistoryDrawer(!isOpenedOrderHistoryDrawer)
          }
          sx={{
            backgroundColor: '#ffffff',
            width: isOpenedOrderHistoryDrawer ? 40 : 100,
            height: 50,
            borderRadius: '30px 0 0 30px',
            position: 'fixed',
            bottom: '430px',
            right: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {isOpenedOrderHistoryDrawer && chat?.name ? (
            <RemoveCircleOutlineIcon />
          ) : (
            <>
              <AddCircleOutlineIcon />
              <Box sx={{ marginLeft: 1 }}>
                <Typography variant="subtitle2">ประวัติคำสั่งซื้อ</Typography>
              </Box>
            </>
          )}
        </IconButton>
      )}
      {isMobile && chat?.name && (
        <FacebookOrderDrawer
          isOpen={isOpenedOrderDrawer}
          onClose={() => setIsOpenedOrderDrawer(false)}
        />
      )}
      {isMobile && chat?.name && (
        <FacebookOrderHistoryDrawer
          data={chat?.name}
          isOpen={isOpenedOrderHistoryDrawer}
          onClose={() => setIsOpenedOrderHistoryDrawer(false)}
        />
      )}
      <FacebookMessageOrderDetailModal
        isMobile={isMobile}
        isOpen={isOpenedOrderDetailModal}
        onClose={() => setIsOpenedOrderDetailModal(false)}
        data={messageOrderDetail}
      />
      <Grid container spacing={2}>
        <Grid item xs={12} md={3} lg={3} hidden={isMobile && !!page && !!chat}>
          <Card
            sx={{
              height: '90vh',
              padding: 2,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              >
                {page?.imageUrl && (
                  <Box>
                    <ImgTag
                      imageUrl={page?.imageUrl}
                      name={page?.pageName || 'non'}
                      size={30}
                    />
                  </Box>
                )}
                <Button
                  fullWidth
                  color={'inherit'}
                  onClick={(event) =>
                    setAnchorElListPageMenu(event.currentTarget)
                  }
                >
                  <MoreVertIcon />
                  {page ? page.pageName : 'เลือกเพจ'}
                </Button>
                <Menu
                  anchorEl={anchorElListPageMenu}
                  open={openListPageMenu}
                  onClose={() => setAnchorElListPageMenu(null)}
                >
                  {pageList.isLoading ? (
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                      }}
                    >
                      <CircularProgress />
                    </Box>
                  ) : (
                    <>
                      {pageList.data?.map(
                        (item: IFacebookPage, index: number) => (
                          <MenuItem
                            key={index}
                            selected={item.pageId === page?.pageId}
                            onClick={() => {
                              setPage(item)
                              setAnchorElListPageMenu(null)
                            }}
                          >
                            <ImgTag
                              imageUrl={item.imageUrl}
                              name={item.pageName}
                              size={30}
                            />
                            <ListItemText sx={{ marginLeft: 1 }}>
                              {item.pageName}
                            </ListItemText>
                          </MenuItem>
                        ),
                      )}
                    </>
                  )}
                </Menu>
              </Box>
              {tabChat === FacebookTabsChatEnum.ChatArchiveList && (
                <Box>
                  <IconButton
                    onClick={(event) =>
                      setAnchorElFilterMenu(event.currentTarget)
                    }
                  >
                    <FilterAltIcon />
                  </IconButton>
                  <Menu
                    keepMounted
                    anchorEl={anchorElFilterMenu}
                    open={openFilterMenu}
                    onClose={() => setAnchorElFilterMenu(null)}
                  >
                    <FormGroup>
                      <MenuItem
                        onClick={(e) => {
                          setFilter({
                            pending: false,
                            purchased: false,
                            hold: false,
                            cancelled: false,
                          })
                          chatArchiveList.mutate()
                        }}
                      >
                        <LayersClearIcon />
                        <Box sx={{ marginLeft: 1 }}>
                          <Typography variant="subtitle1">ทั้งหมด</Typography>
                        </Box>
                      </MenuItem>
                      {menuItemsTypeFilterChatArchiveList.map(
                        (item, index: number) => (
                          <MenuItem key={index}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={
                                    filter[
                                      item.value as keyof IFacebookFilterMenuChatArchiveList
                                    ]
                                  }
                                  onChange={
                                    onHandleSelectFilterMenuChatArchiveList
                                  }
                                  name={item.value}
                                />
                              }
                              label={item.label}
                            />
                          </MenuItem>
                        ),
                      )}
                    </FormGroup>
                  </Menu>
                </Box>
              )}
            </Box>
            <Divider />
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-around',
                alignItems: 'center',
                width: '100%',
              }}
            >
              <Tabs
                sx={{ width: '100%' }}
                value={tabChat}
                onChange={(
                  event: React.SyntheticEvent,
                  newTab: FacebookTabsChatEnum,
                ) => setTabChat(newTab)}
              >
                <Tab
                  sx={{ width: '50%' }}
                  label="รายชื่อแชท"
                  value={FacebookTabsChatEnum.ChatList}
                />
                <Tab
                  sx={{ width: '50%' }}
                  label="รายชื่อแชทจัดเก็บ"
                  value={FacebookTabsChatEnum.ChatArchiveList}
                />
              </Tabs>
            </Box>
            <Divider />
            <Box
              sx={{
                marginTop: 2,
                width: '100%',
                height: '100%',
                overflowY: 'auto',
              }}
            >
              {tabChat === FacebookTabsChatEnum.ChatList ? (
                <>
                  {chatList.isLoading || !page ? (
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                      }}
                    >
                      {page && chatList.isLoading && <CircularProgress />}
                      {isMobile && !page && (
                        <>
                          <ContactSupportIcon
                            color={'disabled'}
                            sx={{ fontSize: 40 }}
                          />
                          <Typography variant="h3" color="text.disabled">
                            ยังไม่ได้เลือกเพจ
                          </Typography>
                        </>
                      )}
                    </Box>
                  ) : (
                    <>
                      {chatList.data?.map(
                        (item: IFacebookChat, index: number) => (
                          <Button
                            key={index}
                            onClick={() => {
                              setChat({
                                chatId: item.id,
                                userId: item.receiver.id,
                                name: item.receiver.name,
                                email: item.receiver.email,
                                pageId: page?.pageId,
                              })
                              setMessagePaging('')
                              setMessageListData([])
                            }}
                            sx={{
                              width: '100%',
                              padding: 1,
                              backgroundColor:
                                item.id === chat?.chatId
                                  ? 'buttonface'
                                  : undefined,
                            }}
                          >
                            <Box
                              sx={{
                                width: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                                textAlign: 'left',
                              }}
                            >
                              <Box>
                                <ImgTag
                                  imageUrl={
                                    'https://www.alleycat.org/wp-content/uploads/2019/03/FELV-cat.jpg'
                                  }
                                  name={item.receiver.name}
                                />
                              </Box>
                              <Box ml={1} sx={{ flexWarp: 'warp' }}>
                                <Typography
                                  variant="subtitle1"
                                  color={'text.primary'}
                                >
                                  {item.receiver.name}
                                </Typography>
                                <Typography
                                  variant="subtitle2"
                                  color="text.secondary"
                                >
                                  {item.messages[0].message
                                    ? item.messages[0].message.length > 40
                                      ? item.messages[0].message.substring(
                                          0,
                                          40,
                                        ) + '...'
                                      : item.messages[0].message
                                    : 'รูปภาพหรือไฟล์'}
                                </Typography>
                              </Box>
                            </Box>
                          </Button>
                        ),
                      )}
                    </>
                  )}
                </>
              ) : (
                <>
                  {chatArchiveList.isLoading || !page ? (
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                      }}
                    >
                      {page && chatArchiveList.isLoading && (
                        <CircularProgress />
                      )}
                      {isMobile && !page && (
                        <>
                          <ContactSupportIcon
                            color={'disabled'}
                            sx={{ fontSize: 40 }}
                          />
                          <Typography variant="h3" color="text.disabled">
                            ยังไม่ได้เลือกเพจ
                          </Typography>
                        </>
                      )}
                    </Box>
                  ) : (
                    <>
                      {chatArchiveList.data?.records?.map(
                        (item: IFacebookChatArchive, index: number) => (
                          <Button
                            key={index}
                            onClick={() => {
                              setChat({
                                chatId: item.chatId,
                                userId: item.userId,
                                name: item.name,
                                email: item.email,
                                pageId: item.pageId,
                              })
                              setMessagePaging('')
                              setMessageListData([])
                            }}
                            sx={{
                              width: '100%',
                              padding: 1,
                              backgroundColor:
                                item.chatId === chat?.chatId
                                  ? 'buttonface'
                                  : undefined,
                            }}
                          >
                            <Box
                              sx={{
                                width: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                                textAlign: 'left',
                              }}
                            >
                              <Box>
                                <ImgTag
                                  imageUrl={
                                    'https://www.alleycat.org/wp-content/uploads/2019/03/FELV-cat.jpg'
                                  }
                                  name={item.name}
                                />
                              </Box>
                              <Box ml={1} sx={{ flexWarp: 'warp' }}>
                                <Typography
                                  variant="subtitle1"
                                  color={'text.primary'}
                                >
                                  {item.name}
                                </Typography>
                                <Tag
                                  color={
                                    item.status ===
                                    FacebookFilterMenuEnum.Purchased
                                      ? 'success'
                                      : item.status ===
                                          FacebookFilterMenuEnum.Pendding
                                        ? 'info'
                                        : item.status ===
                                            FacebookFilterMenuEnum.Hold
                                          ? 'warning'
                                          : item.status ===
                                              FacebookFilterMenuEnum.Cancelled
                                            ? 'error'
                                            : 'default'
                                  }
                                >
                                  <Typography variant="subtitle2">
                                    {item.status}
                                  </Typography>
                                </Tag>
                              </Box>
                            </Box>
                          </Button>
                        ),
                      )}
                    </>
                  )}
                </>
              )}
            </Box>
          </Card>
        </Grid>
        <Grid
          item
          xs={isOpenedOrderDrawer || isOpenedOrderHistoryDrawer ? 10 : 12}
          md={isOpenedOrderDrawer || isOpenedOrderHistoryDrawer ? 5 : 9}
          lg={isOpenedOrderDrawer || isOpenedOrderHistoryDrawer ? 5 : 9}
          hidden={isMobile && (!page || !chat)}
        >
          {chat ? (
            <Card
              sx={{
                paddingTop: 2,
                paddingX: 2,
                height: '90vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Box
                sx={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                  }}
                >
                  {isMobile && (
                    <Box>
                      <IconButton
                        onClick={() => {
                          setChat(undefined)
                          setMessagePaging('')
                          setMessageListData([])
                        }}
                      >
                        <ArrowBackIosIcon />
                      </IconButton>
                    </Box>
                  )}
                  <Box mr={1}>
                    <ImgTag
                      imageUrl={
                        'https://www.alleycat.org/wp-content/uploads/2019/03/FELV-cat.jpg'
                      }
                      name={chat.name}
                      size={isMobile ? 35 : 45}
                    />
                  </Box>
                  <Box>
                    <Typography variant="h4" color="text.primary">
                      {chat.name}
                    </Typography>
                  </Box>
                </Box>
                <Box>
                  <IconButton
                    onClick={(event) =>
                      setAnchorElMenuSetStatusChat(event.currentTarget)
                    }
                  >
                    <MenuTwoToneIcon />
                  </IconButton>
                  <Menu
                    keepMounted
                    anchorEl={anchorElMenuSetStatusChat}
                    open={openMenuSetStatusChat}
                    onClose={() => setAnchorElMenuSetStatusChat(null)}
                  >
                    <FormGroup>
                      {menuItemsTypeFilterChatArchiveList.map(
                        (item, index: number) => (
                          <MenuItem
                            key={index}
                            onClick={(e) =>
                              onHandleSelectSetStatusChat(
                                item.value as FacebookFilterMenuEnum,
                              )
                            }
                          >
                            {item.value === FacebookFilterMenuEnum.Purchased ? (
                              <DoneTwoToneIcon />
                            ) : item.value ===
                              FacebookFilterMenuEnum.Pendding ? (
                              <HourglassEmptyTwoToneIcon />
                            ) : item.value === FacebookFilterMenuEnum.Hold ? (
                              <WarningAmberTwoToneIcon />
                            ) : item.value ===
                              FacebookFilterMenuEnum.Cancelled ? (
                              <CloseTwoToneIcon />
                            ) : (
                              <></>
                            )}
                            <Box sx={{ marginLeft: 1 }}>
                              <Typography variant="subtitle2">
                                {item.label}
                              </Typography>
                            </Box>
                          </MenuItem>
                        ),
                      )}
                    </FormGroup>
                  </Menu>
                </Box>
              </Box>
              <Divider />
              <Box
                sx={{
                  marginTop: 2,
                  width: '100%',
                  height: '100%',
                  overflowY: 'auto',
                }}
              >
                <InfiniteScroll
                  pageStart={0}
                  loadMore={onHandleMessageList}
                  hasMore={!!messagePaging}
                  loader={
                    <div
                      className="loader"
                      key={0}
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        margin: '10px',
                      }}
                    >
                      {isLoadingMessage && <CircularProgress />}
                    </div>
                  }
                  isReverse={true}
                  useWindow={false}
                >
                  {messageListData?.map(
                    (messageObject: IFacebookMessage, index: number) => {
                      const {
                        from,
                        message,
                        sticker,
                        attachments,
                        attachment,
                        created_time,
                      } = messageObject
                      const isPageMessage = from.id === chat.pageId
                      const isBeforeMessageFromThisPerson =
                        messageListData[index - 1]?.from.id === from.id
                      const isAfterMessageFromThisPerson =
                        messageListData[index + 1]?.from.id === from.id
                      const messageType = message
                        ? 'message'
                        : sticker
                          ? 'sticker'
                          : (attachments?.data?.length || 0) > 0
                            ? 'image'
                            : attachment
                              ? 'order'
                              : ''

                      const currentMessageTime = new Date(
                        created_time,
                      ).getTime()
                      const previousMessageTime = new Date(
                        messageListData[index - 1]?.created_time,
                      ).getTime()
                      const nextMessageTime = new Date(
                        messageListData[index + 1]?.created_time,
                      ).getTime()

                      const isMessageDiffFromCurrentBeforeAndAfter =
                        messageListData[index - 1]?.from.id !== from.id &&
                        messageListData[index + 1]?.from.id !== from.id

                      const isMessageDateDiff =
                        Math.abs(nextMessageTime - currentMessageTime) >
                        3 * 60 * 1000
                      const isMessageDateDiffFromBefore =
                        Math.abs(currentMessageTime - previousMessageTime) >
                        3 * 60 * 1000
                      return (
                        <Box key={index}>
                          {isMessageDateDiff && (
                            <Box
                              sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                fontSize: '12px',
                              }}
                            >
                              <Typography
                                variant="caption"
                                color="text.secondary"
                              >
                                {dayjs(currentMessageTime)
                                  .locale('th')
                                  .format('D MMM YYYY HH:mm')}
                              </Typography>
                            </Box>
                          )}
                          <Box
                            sx={{
                              marginTop: 1,
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'start',
                              justifyContent: isPageMessage
                                ? 'flex-end'
                                : 'flex-start',
                            }}
                          >
                            {!isPageMessage &&
                            (!isAfterMessageFromThisPerson ||
                              isMessageDiffFromCurrentBeforeAndAfter ||
                              isMessageDateDiffFromBefore) ? (
                              <Box sx={{ marginRight: '7px' }}>
                                <ImgTag
                                  imageUrl={
                                    'https://www.alleycat.org/wp-content/uploads/2019/03/FELV-cat.jpg'
                                  }
                                  name={chat.name}
                                  size={isMobile ? 30 : 40}
                                />
                              </Box>
                            ) : (
                              <Box
                                sx={{
                                  marginRight: isMobile ? '37px' : '47px',
                                }}
                              />
                            )}

                            {messageType === 'message' ? (
                              <Box
                                sx={{
                                  borderRadius: '15px',
                                  backgroundColor: isPageMessage
                                    ? '#0084FF'
                                    : '#F0F0F0',
                                  whiteSpace: 'pre-wrap',
                                  overflowWrap: 'break-word',
                                  maxWidth: isMobile ? '200px' : '600px',
                                  paddingY: '3px',
                                  paddingX: '7px',
                                }}
                              >
                                <Typography
                                  variant="subtitle1"
                                  sx={{
                                    color: isPageMessage
                                      ? '#ffffff'
                                      : '#000000',
                                  }}
                                >
                                  {message}
                                </Typography>
                              </Box>
                            ) : messageType === 'sticker' ? (
                              <Box key={sticker}>
                                <img
                                  src={sticker}
                                  alt={sticker}
                                  style={{
                                    maxWidth: isMobile ? '40px' : '60px',
                                  }}
                                />
                              </Box>
                            ) : messageType === 'image' ? (
                              <Box
                                sx={{
                                  maxWidth: '400px',
                                }}
                              >
                                {attachments?.data?.map(
                                  (
                                    item: IFacebookAttachments,
                                    index: number,
                                  ) => (
                                    <Box key={index}>
                                      <img
                                        src={item.image_data.url}
                                        alt={item.image_data.url}
                                        style={{
                                          maxWidth: isMobile
                                            ? '200px'
                                            : '300px',
                                          maxHeight: isMobile
                                            ? '200px'
                                            : '300px',
                                          objectFit: 'cover',
                                          borderRadius: '15px',
                                          marginRight: 2,
                                          marginTop: 2,
                                        }}
                                      />
                                    </Box>
                                  ),
                                )}
                              </Box>
                            ) : messageType === 'order' ? (
                              <Box>
                                {attachment?.payload.elements.map(
                                  (item, index: number) => (
                                    <Card
                                      key={index}
                                      sx={{ padding: 2, cursor: 'pointer' }}
                                      onClick={() => {
                                        setMessageOrderDetail({
                                          title: item.title,
                                          subtitle: item.subtitle,
                                          quantity: item.quantity,
                                          price: item.price,
                                          currency: item.currency,
                                          image_url: item.image_url,
                                        })
                                        setIsOpenedOrderDetailModal(true)
                                      }}
                                    >
                                      <Box>
                                        <ImgTag
                                          imageUrl={item.image_url}
                                          name={item.title}
                                          size={40}
                                        />
                                      </Box>
                                      <Box>
                                        <Typography variant="subtitle1">
                                          {item.title}
                                        </Typography>
                                        <Typography variant="subtitle2">
                                          {item.subtitle}
                                        </Typography>
                                        <Typography variant="subtitle2">
                                          {item.quantity} x {item.price}{' '}
                                          {item.currency}
                                        </Typography>
                                      </Box>
                                    </Card>
                                  ),
                                )}
                              </Box>
                            ) : (
                              <></>
                            )}
                          </Box>
                        </Box>
                      )
                    },
                  )}
                </InfiniteScroll>
              </Box>
              <Box sx={{ width: '100%' }}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    overflowX: 'auto',
                  }}
                >
                  {images?.map((item: string, index: number) => (
                    <Box mr={1} key={index}>
                      <ImgTag
                        imageUrl={item}
                        name={item}
                        isShowCancel={true}
                        onCancel={(value) => {
                          setImages(
                            images?.filter((item: string) => item !== value),
                          )
                        }}
                      />
                    </Box>
                  ))}
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'end',
                    justifyContent: 'space-between',
                    backgroundColor: '#ffffff',
                    padding: 1,
                  }}
                >
                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    style={{ display: 'none' }}
                    onChange={onHandleSelectMultiFileChange}
                    id="file-input"
                  />
                  <label htmlFor="file-input">
                    <IconButton component="span">
                      <CloudUploadIcon />
                    </IconButton>
                  </label>
                  <Box sx={{ width: '90%' }}>
                    <TextField
                      variant="outlined"
                      id="replyMessage"
                      name="replyMessage"
                      multiline
                      maxRows={5}
                      onKeyDown={(e: React.KeyboardEvent) =>
                        e.key === 'Enter' && onHandleSendReplyMessage()
                      }
                      fullWidth
                      size={'small'}
                      placeholder={'Aa'}
                      value={replyMessage}
                      onChange={(e) => setReplyMessage(e.target.value)}
                    />
                  </Box>
                  <IconButton
                    onClick={async () => {
                      await onHandleSendReplyMessage()
                      await onHandleSendImage()
                    }}
                  >
                    <SendIcon />
                  </IconButton>
                </Box>
              </Box>
            </Card>
          ) : (
            <Card
              sx={{
                paddingTop: 2,
                paddingX: 2,
                height: '90vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <ContactSupportIcon color={'disabled'} sx={{ fontSize: 120 }} />
              <Typography variant="h1" color="text.disabled">
                {page ? 'ยังไม่ได้เลือกแชท' : 'ยังไม่ได้เลือกเพจ'}
              </Typography>
            </Card>
          )}
        </Grid>
        {isOpenedOrderDrawer && !isMobile && (
          <Grid item xs={12} md={4} lg={4}>
            <Card
              sx={{
                paddingTop: 2,
                paddingX: 2,
                height: '90vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'flex-start',
                overflowY: 'auto',
              }}
            >
              <Box>
                <FacebookOrder />
              </Box>
            </Card>
          </Grid>
        )}
        {isOpenedOrderHistoryDrawer && !isMobile && chat?.name && (
          <Grid item xs={12} md={4} lg={4}>
            <Card
              sx={{
                paddingTop: 2,
                paddingX: 2,
                height: '90vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'flex-start',
                overflowY: 'auto',
              }}
            >
              <FacebookOrderHistory data={chat?.name} />
            </Card>
          </Grid>
        )}
      </Grid>
    </>
  )
}

export default FacebookReplyChat
